import type { ComponentStyleConfig } from "@chakra-ui/react";

export const inputStyle: ComponentStyleConfig = {
  variants: {
    filled: {
      field: {
        border: "1px",
        bg: "white",
        color: "black",
        borderRadius: "5px",
        _placeholder: {
          color: "secondary",
        },
        _hover: {
          bg: "white",
        },
        _focus: {
          bg: "white",
        },
        _focusVisible: {
          bg: "white",
          borderColor: "primary",
        },
      },
    },
  },
  defaultProps: {
    variant: "filled",
  },
};
